namespace Portico.Models.Enterprise {

    export interface ILinkedPayor {
    }

	export class LinkedPayor implements ILinkedPayor {

		constructor(obj?: ILinkedPayor) {
            if (obj) {
            }
        }
    }
}
